import React, { useEffect } from 'react';

const DEFAULT_NOT_FOUND_MESSAGE = 'Vessel Serial Number not found in Vessel Inventory.';

const SerialValidationModal = ({ isOpen, message, title, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const trimmedMessage = String(message || '').trim();
  const isNotFound =
    !trimmedMessage ||
    /not found|not\s+in.*inventory/i.test(trimmedMessage);

  const headerTitle = title || (isNotFound ? 'Vessel Serial Number Not Found' : 'Unable to Submit Form');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black bg-opacity-70" onClick={onClose} />

      <div className="relative pvs-glass border border-pvs-border rounded-xl shadow-2xl max-w-md w-full p-0 overflow-hidden animate-in">
        {/* Red header bar */}
        <div className="bg-red-600 px-6 py-4 flex items-center gap-3">
          <svg className="h-7 w-7 text-white flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <h2 className="text-white text-lg font-bold">{headerTitle}</h2>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-white text-base font-semibold leading-relaxed">
            {trimmedMessage || DEFAULT_NOT_FOUND_MESSAGE}
          </p>
          {isNotFound && (
            <p className="text-pvs-text-dim text-sm mt-3">
              The serial number entered does not match any vessel currently in the system. Please verify the serial number on the vessel data plate and try again.
            </p>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 pb-5 flex justify-end">
          <button
            onClick={onClose}
            autoFocus
            className="px-6 py-2.5 bg-pvs-accent text-pvs-bg font-semibold rounded-lg shadow hover:bg-pvs-accent-dim focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pvs-accent/50 transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SerialValidationModal;
